let childrenSys = [ {
        path: '/Sys_Sys',
        name: 'Sys_Sys',
        component: () => import('@/view/Sys/Sys_Sys/list')
    }
    , {
        path: '/Sys_Roles',
        name: 'Sys_Roles',
        component: () => import('@/view/Sys/Sys_Roles/list')
    }
    , {
        path: '/Sys_Menus',
        name: 'Sys_Menus',
        component: () => import('@/view/Sys/Sys_Menus/list')
    }
    , {
        path: '/Sys_Api',
        name: 'Sys_Api',
        component: () => import('@/view/Sys/Sys_Api/list')
    }
    , {
        path: '/Sys_Dic',
        name: 'Sys_Dic',
        component: () => import('@/view/Sys/Sys_Dic/list')
    }, {
        path: '/SysUser',
        name: '用户管理',
        component: () => import('@/view/Sys/Sys_User/list')
    },
    {
      path: '/UserInfo',
      name: 'UserInfo',
      component: () => import('@/view/Sys/Sys_User/userInfo')
    }, {
        path: '/CreateCode',
        name: 'CreateCode',
        component: () => import('@/view/Sys/Sys_CreateCode/list')
      },
];
export default childrenSys



// WEBPACK FOOTER //
// ./src/router/childrenSys.js